<template>
  <div>
    <template v-if="!successfulUpdate">
      <update-card :options="updateVisaCardOptions" @token="getToken" @ingenicoCheck="nextStep">
      </update-card>
    </template>

    <template v-else>
      <message-page :options="messageOptions" @btnClick="handleBtnConfirm"></message-page>
    </template>
  </div>
</template>

<script>
  import UpdateCard from '../SignUp/componets/Step1';
  import MessagePage from '@/components/MessagePage';
  import { mapState } from 'vuex';
  // import { handleCreateSession } from '@/utils/createSession';

  export default {
    name: 'UpdateVisaCard',

    components: {
      UpdateCard,
      MessagePage,
    },

    data() {
      return {
        token: '',
        successfulUpdate: false,
        messageOptions: {
          title: 'msg-success-card-update',
          desc: [
            { content: 'update-modal-success-desc1', need: true },
            { content: 'update-modal-success-desc2' },
          ],
          btnTitle: 'btn-go-home',
          dragoncodeLast4: '',
          visaCardLast4: '',
        },
        updateVisaCardOptions: {
          title: 'uvcard-title',
          subtitle: 'uvcard-sub-title',
          desc: 'uvcard-sub-desc',
          warring: 'uvcard-warring',
          noPerform: true,
          source: 3, // 更新卡
        },
        cardInfoToken: '',
      };
    },

    computed: {
      ...mapState(['userInfo']),
    },

    methods: {
      getToken(token) {
        this.token = token;
      },

      nextStep(value) {
        this.$loading.show();
        this.cardInfoToken = value.cardInfoToken;
        this.updateVisaCard(value.paymentHash);
      },

      updateVisaCard(paymentHash = '') {
        const { userId, sessionId } = this.userInfo;
        const { dpid } = this.$route.query;
        const data = {
          userId,
          visaToken: this.token,
          encryptCustomerInput: paymentHash,
          sessionId,
          device: 'web',
          lang: this.$i18n.locale,
          infoToken: this.cardInfoToken,
          dragoncode: dpid,
        };

        this.$http.member
          .updateVisaCard(data)
          .then(res => {
            if (res?.state === '11') {
              const { dragoncodeLast4, visaCardLast4 } = res.data;
              this.successfulUpdate = 'ture';
              this.messageOptions.dragoncodeLast4 = dragoncodeLast4;
              this.messageOptions.visaCardLast4 = visaCardLast4;

              // 如果有 dpid, 则更新默认卡
              if (dpid) {
                // 更新卡成功, 切换默认卡
                const newCard = {
                  dragonCode: dpid,
                  userId,
                  sessionId,
                };
                this.$http.member.setDefaultCard(newCard).then(res => {
                  if (res?.state === '11') {
                    this.$router.push({
                      name: 'Membership',
                    });
                  } else {
                    this.$messageModal.show({
                      image: false,
                      closeIcon: true,
                      desc: res?.note,
                      confirmBtn: 'ok',
                      justHide: true,
                      i18nNeed: false,
                    });
                  }
                });
              }
            } else if (res.state === '00' && res?.errorCode === 'visa.card.ingenico.fail') {
              this.$messageModal.show({
                image: false,
                descGroup: {
                  desc1: 'mayHave',
                  desc2: 'reEntering',
                  subDesc: ['have1', 'have2', 'have3'],
                },
                confirmBtn: 'ok',
                justHide: true,
              });
            } else {
              res?.note &&
                this.$messageModal.show({
                  image: false,
                  closeIcon: true,
                  desc: res?.note,
                  confirmBtn: 'ok',
                  justHide: true,
                  i18nNeed: false,
                });
            }
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            this.$loading.hide();
          });
      },

      handleBtnConfirm() {
        const { dpid } = this.$route.query;
        if (dpid) {
          this.$router.push('/account/membership');
        } else {
          this.$router.push('/');
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index';
</style>
